
<template>
  <Header/>
  <div class="ins-root bs-fit">
    <StatFilters
      :conversions="statConversions"
      @apply="fetchData"
      @min-sessions="onMinSessions"
    />
    <div class="bs-bar">
      <button type="button" class="btn" @click="toggleHeads">
        {{ shortHeads ? '⤢ Развернуть заголовки' : '⤡ Свернуть заголовки' }}
      </button>
      <span class="bs-hint">Полное название колонки — во всплывающей подсказке</span>
    </div>
    <div class="bs-grid">
      <ag-grid-vue
        :rowData="rowData"
        :columnDefs="colDefs"
        :context="gridContext"
        class="ag-theme-quartz bs-ag"
        :class="{ 'is-short': shortHeads }"
      >
      </ag-grid-vue>
    </div>
    <WordUtmModal
      v-if="wordModal"
      :word="wordModal.word"
      :blockName="wordModal.blockName"
      :utm="wordModal.utm"
      @close="wordModal = null"
    />
  </div>
</template>

<style>
.ag-theme-quartz {
  --ag-header-height: 130px;
}
.ag-cell-value {
  white-space: pre-wrap; /* сохраняет пробелы и переносы строк */
}
/* Высоту гриду задаём здесь, а не процентом от страницы: своя высота ag-grid
   описана как height:100% (.ag-root-wrapper.ag-layout-normal), и процент
   разрешится только от «определённой» высоты родителя.
   Флекс-раскладку тут применять нельзя: при ней ag-grid при инициализации
   меряет себя до раскладки и растягивает каждую колонку на всю ширину
   контейнера вместо дефолтных 200px.

   Грид ровно в высоту экрана и последний на странице, а нижнего отступа нет —
   поэтому прокрутка вниз заканчивается ровно в тот момент, когда строка
   заголовков столбцов встаёт к верхней кромке экрана, а горизонтальная полоса
   прокрутки — к нижней. Прокрутка вверх возвращает шапку сайта и фильтры.
   Липкое позиционирование для этого не годится: грид упирается в нижний край
   родителя, и ходить ему там негде. */
.bs-grid { height: 100vh; min-height: 420px; }
/* Два класса, а не один: у .ins-root padding задан сокращённой записью,
   и при равной специфичности исход решал бы порядок подключения стилей. */
.ins-root.bs-fit { padding-bottom: 0; }
.bs-ag { width: 100%; height: 100%; }
/* Свёрнутые заголовки: короткое название в одну-две строки.
   autoHeaderHeight растянет строку заголовков, если название перенеслось. */
.bs-ag.is-short { --ag-header-height: 40px; }

.bs-bar { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
.bs-hint { font-size: 12px; color: var(--text-muted); }
</style>

<script>
/*

*/
import axios from "axios";
// Получение токена из localStorage
const token = localStorage.getItem('token');
// Добавление токена в заголовок Authorization для всех запросов
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AgGridVue } from "ag-grid-vue3"; // AG Grid Component
import Header from '@/components/Header.vue';
import WordCell from '@/components/WordCell.vue';
import WordUtmModal from '@/components/WordUtmModal.vue';
import StatFilters from '@/components/StatFilters.vue';
import { aggregateWords, filterWordsByMinSessions } from '@/utils/wordStat';
import { apiHost } from '@/utils/statFilters';
// Свёрнутый заголовок должен читаться и помещаться в те же 200px, что и колонка,
// поэтому короткие названия подобраны в одну-две строки. Полное название
// колонки всегда доступно в подсказке (headerTooltip).
const BASE = { autoHeaderHeight: true, wrapHeaderText: true };
const WIDE = { autoHeaderHeight: true, wrapHeaderText: true, autoHeight: true, wrapText: true };

const COLUMNS = [
  { short: "Блок", full: "Название", def: Object.assign({ field: "f10", pinned: "left" }, BASE) },
  { short: "Дубли", full: "Дубли", def: Object.assign({ field: "dubleBlock" }, BASE) },
  { short: "Разворот вниз", full: "Разворот вниз на блоке", def: Object.assign({ field: "f20" }, BASE) },
  { short: "Разворот вверх", full: "Разворот вверх на блоке", def: Object.assign({ field: "f30" }, BASE) },
  { short: "Разворот вверх, первый", full: "Разворот вверх на блоке (Первый)", def: Object.assign({ field: "f35" }, BASE) },
  { short: "Ушли с блока", full: "Ушли с блока при первом проходе вниз (без разворота)", def: Object.assign({ field: "f40" }, BASE) },
  { short: "Скоринг нерелевантности", full: "Общий скоринг нерелевантности блок", def: Object.assign({ field: "f50" }, BASE) },
  { short: "Прочитали и пошли дальше", full: "Сколько зашло на блок, прочитало (более 1 секунды), и перешло на следующий блок - пролистало вниз (не вышло и не ушло в разворот вверх)", def: Object.assign({ field: "f60" }, BASE) },
  { short: "Всего зашло", full: "Всего зашло на блок (долистало до блока без разворота или перешли с меню на этот блок (то есть прокрутка вниз только учитывается - до разворота). Независимо от проведенного времени на данном блоке - даже если 0 сек (с учетом блока разворота)", def: Object.assign({ field: "f70" }, BASE) },
  { short: "Доходимость, %", full: "Процент доходимости в блоке", def: Object.assign({ field: "f80" }, BASE) },
  { short: "Нерелевантность, %", full: "Процент от ВСЕГО ЗАШЛО к общему скорингу нерелевантности блока", def: Object.assign({ field: "f90" }, BASE) },
  { short: "Потеряно людей", full: "Количество пользователей, потерянных на блоке", def: Object.assign({ field: "f100" }, BASE) },
  { short: "Качество чтения, %", full: "Процент от зашедших на блок, к тем кто его читает и переходит к следующему (качество ознакомления с информацией в блоке) (процент)", def: Object.assign({ field: "f110" }, BASE) },
  { short: "Пролистали сами", full: "Пролистали блок сколько раз (сами менее 1 секунды) до разворота", def: Object.assign({ field: "f120" }, BASE) },
  { short: "Пролистали из меню", full: "Пролистали блок сколько раз (автоматически из-за выбранного пункта меню) до разворота", def: Object.assign({ field: "f130" }, BASE) },
  { short: "Аффинити: времена, с выбросами", full: "Аффинити к блоку (стремление его читать,  - среднее время и количество пользователей при расчете выборки которые смотрели этот блок) до разворота. (с выбросами)", def: Object.assign({ field: "f140" }, WIDE) },
  { short: "Аффинити: людей, с выбросами", full: "Аффинити к блоку  - количество пользователей (с выбросами)", def: Object.assign({ field: "f150" }, BASE) },
  { short: "Аффинити: ср. время, с выбросами", full: "Аффинити к блоку  - среднее время (с выбросами)", def: Object.assign({ field: "f160" }, BASE) },
  { short: "Аффинити: времена, без выбросов", full: "Аффинити к блоку (стремление его читать,  - среднее время и количество пользователей при расчете выборки которые смотрели этот блок) до разворота.  (без выбросов)", def: Object.assign({ field: "f170" }, WIDE) },
  { short: "Аффинити: людей, без выбросов", full: "Аффинити к блоку  - количество пользователей (без выбросов)", def: Object.assign({ field: "f180" }, BASE) },
  { short: "Аффинити: ср. время, без выбросов", full: "Аффинити к блоку  - среднее время (без выбросов)", def: Object.assign({ field: "f190" }, BASE) },
  { short: "Кликов по меню", full: "Аффинити к блоку (стремление его читать) - количество нажатий на пункт меню, обозначающий данный блок (нажатие на меню независимо от блока где в этот момент находится пользователь)  до разворота", def: Object.assign({ field: "f200" }, BASE) },
  { short: "Долистали вручную", full: "Аффинити к блоку - количество раз где пролистывали все блоки до этого - вручную, без использования меню (менее 1 секунды), а на данном блоке задержались на более чем 1 секунду (при прокрутке вниз - до разворота)", def: Object.assign({ field: "f210" }, BASE) },
  { short: "utm_term", full: "Разрез по utm_term", def: Object.assign({ field: "statUtm" }, WIDE) },
  { short: "Слова", full: "Разрез по слову — метрики по отдельным словам из utm_term", def: Object.assign({ field: "statWord", cellRenderer: WordCell }, WIDE) },
  { short: "Device", full: "Разрез по device", def: Object.assign({ field: "statDevice" }, WIDE) },
  { short: "События до разворота", full: "События на блоке до разворота", def: Object.assign({ field: "events" }, WIDE) },
  { short: "События", full: "События на блоке", def: Object.assign({ field: "eventsAll" }, WIDE) },
];

// Состояние «свёрнуто/развёрнуто» переживает перезагрузку.
const HEADS_KEY = 'blockStatHeads';

export default {
  components: {
   AgGridVue, // Add AG Grid Vue3 component
   Header,
   WordUtmModal,
   StatFilters,
  },
  computed: {
    // headerName переключается между полным и коротким названием; полное
    // всегда остаётся в подсказке, поэтому смысл колонки не теряется.
    colDefs() {
      const short = this.shortHeads;
      return COLUMNS.map(col => Object.assign({}, col.def, {
        headerName: short ? col.short : col.full,
        headerTooltip: col.full,
      }));
    },
  },
  data() {
    return {
      clientId: '',
      shortHeads: localStorage.getItem(HEADS_KEY) !== 'full',
      data: null,
      statConversions: null,
      rowData: [],
      wordModal: null,
      // Контекст создаётся один раз и не меняется — колбэк стабилен.
      gridContext: { onWordClick: null },
      minSessions: '',
      requested: false,
      reqId: 0,
    };
  },
  mounted() {
    this.gridContext.onWordClick = this.openWordModal;
    document.documentElement.style.setProperty('--app-nav-position', 'static');
  },
  beforeUnmount() {
    document.documentElement.style.removeProperty('--app-nav-position');
  },
  methods: {
    toggleHeads() {
      this.shortHeads = !this.shortHeads;
      localStorage.setItem(HEADS_KEY, this.shortHeads ? 'short' : 'full');
    },
    onMinSessions(value) {
      this.minSessions = value;
      this.applyWordFilter();
    },
    getBlockName(index) {
      
      if (index < 0) {
        index = 0;
      }
      
      
      const keys = Object.keys(this.data);
      if (index > keys.length-1) {
        index = keys.length-1
      }
      //console.log(index, keys.length, keys[index]);
      if (index >= 0 && index < keys.length) {
        //console.log('+');
        return keys[index];
      } else {
        //console.log('-');
        return ''; // или другое значение, если предыдущего блока нет
      }
    },
    // Порог — косметика только для колонки statWord: пересобираем её из
    // сохранённого полного агрегата, не трогая остальные колонки и не ходя в API.
    applyWordFilter() {
      this.rowData = this.rowData.map(row => ({
        ...row,
        statWord: filterWordsByMinSessions(row.wordsAll, this.minSessions),
      }));
    },
    openWordModal(word, row) {
      this.wordModal = { word: word, blockName: row.f10, utm: row.utmRaw };
    },
    fetchData(params) {
      const reqId = ++this.reqId;
      axios.post(apiHost() + '/api/v1/getstream',
        {
          clientId: localStorage.getItem('clientId'),
          token: params.token,
          utmGroupId: params.utmGroupId,
          dateStart: params.dateStart,
          dateEnd: params.dateEnd,
        })
        .then(response => {
          if (reqId !== this.reqId) return;
          this.data = response.data.sortedObjects;
          //console.log(response.data);
          this.requested = true;
          let data = response.data.sortedObjects;
          this.statConversions = response.data.statConversions;
          let arr = [];
          let index = 0;
          for (let name in data) {
            console.log('index', index);
            console.log('name', name);
            console.log(data);
            let obj = {
              f10: name,
              dubleBlock: data[name].dubleBlock,
              f20: data[name].down,
              f30: data[name].up,
              f35: data[name].upFirst,
              f40: data[name].left,
              f50: data[name].upFirst+data[name].left,
              f60: data[name].countToRead,
              f70: data[name].countToView,
              f80: (data[this.getBlockName(index)].countToView / data[this.getBlockName(0)].countToView*100).toFixed(2),
              f90: ((data[name].upFirst + data[name].left)/data[name].countToView*100).toFixed(2),
              f100: data[this.getBlockName(index)].countToView - data[this.getBlockName(index+1)].countToView,
              f110: (data[name].countToRead/data[name].countToView*100).toFixed(2),
              f120: data[name].scrolledBlockWithoutMenu,
              f130: data[name].scrolledBlockFromMenu,
              f140: data[name].arrSecondView,
              f150: data[name].lengthArrSecondView,
              f160: data[name].avgSecondView ? data[name].avgSecondView.toFixed(0) : 0,
              f170: data[name].filteredArrSecondView,
              f180: data[name].lengthFilteredArrSecondView,
              f190: data[name].avgFilteredSecondView ? data[name].avgFilteredSecondView.toFixed(0) : 0,
              f200: data[name].clickToMenu,
              statUtm: objectToHtml(data[name].utm),
              utmRaw: data[name].utm,
              wordsAll: aggregateWords(data[name].utm),
              statDevice: objectToHtml(data[name].device),
              events: objectToHtmlEvents(data[name].events),
              eventsAll: objectToHtmlEvents(data[name].eventsAll),
            }
            arr.push(obj);
            index++
          }
          this.rowData = arr;
          this.applyWordFilter();
          console.log(this.rowData);
        })
        .catch(error => {
          if (reqId !== this.reqId) return;
          console.error('Ошибка при запросе данных:', error);
        });
    }
  },
};


function objectToHtml(obj) {
  let htmlString = '';

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let entry = `${key}; `;
      let values = [];

      for (let subKey in obj[key]) {
        if (obj[key].hasOwnProperty(subKey)) {
          values.push(`${subKey}:${obj[key][subKey]}`);
        }
      }

      entry += values.join(', ');
      htmlString += `${entry}\n`;
    }
  }

  return htmlString;
}
function objectToHtmlEvents(obj) {
  let htmlString = '';

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let entry = ``;
      let values = [];

      values.push(`${key}:${obj[key]}`);

      entry += values.join(', ');
      htmlString += `${entry}\n`;
    }
  }

  return htmlString;
}
</script>